import { Box, RoleGuard } from 'portal-commons';
import { FunctionComponent, useState } from 'react';
import { faBullhorn, faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid } from '@material-ui/core';

import CampaignDescription from '../CampaignDescription';
import CampaignDetailsEditModal from '../CampaignDetailsEditModal';
import { updateCampaign } from '../../apis';
import { CampaignDetail, CampaignDetailsUpdatePayload } from '../../types';
import { toastFlashMessage } from '@/utils';

interface CampaignDetailsSectionProps {
  disabled?: boolean;
  campaign: CampaignDetail;
  onChange?: (data: CampaignDetailsUpdatePayload) => void;
  greyOutFields?: Array<string>;
}

const CampaignDetailsSection: FunctionComponent<
  CampaignDetailsSectionProps
> = ({ disabled, campaign, onChange, greyOutFields = [] }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: CampaignDetailsUpdatePayload) => {
    setLoading(true);
    const response = await updateCampaign(campaign.uid, data);
    if (response) {
      setModalOpen(false);
      onChange?.(data);
      toastFlashMessage('Campaign updated successfully', 'success');
    }
    setLoading(false);
  };

  return (
    <Grid item xs={12}>
      <div
        className="description details"
        data-testid="campaignDetailsCampaignDetails"
      >
        <div className="details-heading">
          <Box flexDirection="row" alignItems="center">
            <Box margin={{ right: 'xs' }}>
              <FontAwesomeIcon icon={faBullhorn} size="xl" />
            </Box>
            <h3 className="heading1">Campaign Details</h3>
          </Box>
          <RoleGuard feature="campaignDetail.editCampaignDetails">
            <div
              data-testid="campaignDetailsCampaignDetailsEditButton"
              className={disabled ? 'edit-btn disabled' : 'edit-btn'}
              onClick={disabled ? undefined : () => setModalOpen(true)}
            >
              <Box flexDirection="row" alignItems="center">
                <Box margin={{ right: 'xs' }}>
                  <FontAwesomeIcon icon={faPen} color="#0091B3" />
                </Box>
                <span>Edit</span>
              </Box>
            </div>
          </RoleGuard>
        </div>
        <CampaignDescription
          description={campaign.description}
          messageFlow={campaign.messageFlow}
          privacyPolicyLink={campaign.privacyPolicyLink}
          termsAndConditionsLink={campaign.termsAndConditionsLink}
        />
      </div>
      <CampaignDetailsEditModal
        open={modalOpen}
        disabled={loading}
        campaign={campaign}
        onClose={() => setModalOpen(false)}
        onSubmit={handleSubmit}
        greyOutFields={greyOutFields}
      />
    </Grid>
  );
};

export default CampaignDetailsSection;
